import { ElMessage } from 'element-plus'
import { t, lang } from '@/plugins/i18n'
import store from '../index'

interface State {
  isInstall: boolean
}

export default {
  namespaced: true,
  state: {
    isInstall: false,
    visible: false,
    hasRemind: false,
    interval: null
  },
  getters: {},
  mutations: {},
  actions: {
    uploadImg (store: any, data: any): void {
      const { state } = store
      if (!state.isInstall) {
        state.visible = true
        return
      }
      const type = data[0].type.replace('image/', '')
      if (!type) { ElMessage.error(t('图片格式不正确')); return }
      const src = URL.createObjectURL(data[0])
      const img = new Image()
      img.src = src
      img.onload = () => {
        window.postMessage({
          cmd: 'uploadImg',
          imgData: { src, type, height: img.height, width: img.width }
        }, '*')
      }
    },
    transferUser ({ state }: any, data: any): void {
      // todo:等待 content-script 加载完后
      // clearInterval(state.interval)
      // state.interval = setInterval(() => {
      //   window.postMessage({
      //     cmd: 'transferUser',
      //     userData: data
      //   }, '*')
      // }, 3000)
      console.log('transferUser from client', data)
      clearTimeout(state.timeout)
      state.timeout = setTimeout(() => {
        window.postMessage({
          cmd: 'transferUser',
          userData: data
        }, '*')
      }, 1500)
    }
  },
  local: {
    hasRemind: true
  }
}

window.addEventListener('message', (res: any) => {
  const { isInstall } = res.data ?? {}
  if (isInstall) {
    store.commit('extension/isInstall', isInstall)
    window.postMessage({
      cmd: 'transferLang',
      lang
    }, '*')
  }
})
